import { decodeImage } from '//higgyskin.com/cdn/shop/t/20/assets/utils.js?v=55669923489120135981777434936';

class TestComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.layerId = this.dataset.layerId;
  
    const styles = this.querySelector("template.styles").content.cloneNode(true);
    styles.querySelectorAll("style").forEach((style) => {
      style.textContent = style.textContent.replace(/{{block.id}}/g, this.layerId);
    });
    this.shadowRoot.appendChild(styles);
    const content = this.querySelector("template.root").content.cloneNode(true);
    this.shadowRoot.appendChild(content);
  }
  
  connectedCallback() {
    // console.log(this);

    let images = this.shadowRoot.querySelectorAll('img[data-srcset]');
    decodeImage(images, this);

    // images.forEach(img => {
    //   img.addEventListener('load', (e) => {
    //     console.log('Loaded low-res', e.target.src);
    //     e.target.setAttribute('data-loaded', 'low-res');

    //     let i = new Image();
    //     i.src = e.target.dataset.src;
    //     i.decode().then(() => {
    //       let url = new URL(i.src);
    //       console.log('Decoded high-res', url.pathname);

    //       img.replaceWith(i);
    //       i.setAttribute('data-loaded', 'high-decoded');
    //     });

    //     i.addEventListener('load', (e) => {
    //       let url = new URL(e.target.src);
    //       e.target.setAttribute('data-loaded', 'high-res');
    //       console.log('Loaded high-res', url.pathname);
    //     });
    //   });
    // });
  }
}

customElements.define("test-component", TestComponent);